import { render, staticRenderFns } from "./LandingOnboardingNl.vue?vue&type=template&id=6337a567&scoped=true"
import script from "./LandingOnboardingNl.vue?vue&type=script&lang=js"
export * from "./LandingOnboardingNl.vue?vue&type=script&lang=js"
import style0 from "./LandingOnboardingNl.vue?vue&type=style&index=0&id=6337a567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6337a567",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingMyAdItem: require('/src/components/landing/LandingMyAdItem.vue').default})
